import React from "react";
import "./BlinkingLoader.css";

const BlinkingLoader = () => {
    return (
        <div className="blinking-loader">
            <span className="dot">•</span>
            <span className="dot">•</span>
            <span className="dot">•</span>
        </div>
    );
};

export default BlinkingLoader;
